const getHandlerFor = (callback) => {
  return (event, args) => {
    if (args) {
      const argsArray = [].concat(args);

      callback(...argsArray);
    } else {
      callback();
    }
  };
};

export {
  getHandlerFor,
};



// WEBPACK FOOTER //
// ./client/utils/angular.js